var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){return _vm.qrScud($event)}}},[_c('img',{staticClass:"icon-pdf",attrs:{"src":_vm.iconPath('v_scud.svg'),"alt":""}}),_vm._v(" QR-код посетителя ")])}
var staticRenderFns = []

export { render, staticRenderFns }